<template>
  <a-modal
    :title="type == 'add' ? '添加HR' : '编辑HR'"
    okText="保存"
    @ok="save"
    v-model="visible"
    :width="650"
  >
    <a-form :form="form">
      <a-row :gutter="30" class="editMessage">
        <a-col span="25">
          <a-form-item label="所属公司" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
            <a-select
              v-decorator="[
                'company',
                {
                  rules: [{ required: true, message: '请填写所属公司' }]
                }
              ]"
              showSearch
              placeholder="input search text"
              style="width: 200px"
              :defaultActiveFirstOption="false"
              :showArrow="false"
              :filterOption="false"
              @search="handleSearch"
              :notFoundContent="null"
            >
              <a-select-option
                v-for="(item, index) in data"
                :key="index"
                :value="item.id"
              >{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col span="25">
          <a-form-item label="HR姓名" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
            <a-input
              v-decorator="[
                'name',
                { rules: [{ required: true, message: '请填写HR姓名' }] }
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col span="25">
          <a-form-item label="手机号" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
            <a-input
              v-decorator="[
                'tel',
                { rules: [{ required: true, message: '请填写手机号' }] }
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col span="25">
          <a-form-item label="邮箱" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
            <a-input
              v-decorator="[
                'mail',
                { rules: [{ required: true, message: '请设置邮箱' }] }
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col span="25">
          <a-form-item label="公司座机号" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
            <a-input
              v-decorator="[
                'companyTel',
                { rules: [{ required: false, message: '请设置公司座机号' }] }
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col span="25">
          <a-form-item label="职位title" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
            <a-select
              @change="handleChange"
              initialValue="HR"
              v-decorator="[
                'client',
                { rules: [{ required: false, message: '请选择职位title' }] }
              ]"
            >
              <a-select-option value="hr">HR</a-select-option>
              <a-select-option value="HRBP">HRBP</a-select-option>
              <a-select-option value="HRD">HRD</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";
var timer;
export default {
  name: "EditMessage",
  props: {
    record: {
      type: Object,
      default: () => {
        {
        }
      }
    },
    getListData: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      type: "",
      visible: false,
      data: [],
      value: undefined,
      comoanyValue: undefined
    };
  },
  created() {},
  watch: {},
  methods: {
    save() {
      if (this.type === "edit") {
        this.form.validateFields((err, values) => {
          if (this.record.company_name != values.company) {
            this.value = values.company;
          } else {
            this.value = this.record.hr_company_id;
          }
          if (!err) {
            let params = {
              hr_company_id: this.value,
              id: this.record.id,
              hr_name: values.name,
              hr_mobile: values.tel,
              hr_email: values.mail,
              hr_landline: values.companyTel,
              hr_title: values.client
            };
            Api.hrlist.editHr(params).then(res => {
              if (res) {
                this.$message.success("编辑成功");
                this.visible = false;
                this.getListData();
              } else {
                this.$message.error("编辑失败");
              }
            });
          }
        });
      } else {
        this.form.validateFields((err, values) => {
          if (!err) {
            let params = {
              hr_company_id: values.company,
              hr_name: values.name,
              hr_mobile: values.tel,
              hr_email: values.mail,
              hr_landline: values.companyTel,
              hr_title: values.client
            };
            Api.hrlist.addHr(params).then(res => {
              if (res.id) {
                this.$message.success("添加成功");
                this.visible = false;
                this.getListData();
              } else {
                this.$message.error("添加失败");
              }
            });
          }
        });
      }
    },
    getSuggestApi(value) {
      Api.hrlist.searchCompany({ company_name: value }).then(response => {
        this.data = response;
      });
    },
    debounce(fn, delay) {
      let self = this;
      timer && clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(self);
      }, delay);
    },

    handleSearch(value) {
      if (value.length >= 2) {
        this.debounce(() => this.getSuggestApi(value), 1000);
      }
    },

    handleChange(value) {
      console.log(`selected ${value}`);
    },
    async show() {
      this.visible = true;
      if (this.type === "edit") {
        this.value = this.record.hr_company_id;
        this.$nextTick().then(() => {
          this.form.setFieldsValue({
            company: this.record.company_name,
            name: this.record.hr_name,
            tel: this.record.hr_mobile,
            mail: this.record.hr_email,
            companyTel: this.record.hr_landline,
            client: this.record.hr_title
          });
        });
      } else {
        this.form.resetFields();
        this.value = "";
      }
    },
    close() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss">
.editMessage {
  .ant-select {
    width: 100% !important;
  }
}
</style>
